import { Home, MapPin, Video } from 'lucide-react';

import type { LocationKind } from './types';

/**
 * Canonical kind -> lucide icon map. One source of truth so every location
 * surface (editor, library, slot block, activity chips) renders the same glyph
 * for venue / at_home / online and can never drift apart.
 */
export const KIND_ICON: Record<LocationKind, typeof MapPin> = {
  venue: MapPin,
  at_home: Home,
  online: Video
};

/** Host of a URL (e.g. "zoom.us"), falling back to the raw string for non-URLs. */
export function hostOf(url: string): string {
  try {
    return new URL(url).host || url;
  } catch {
    return url;
  }
}

/** Travel radius in whole kilometers (meters / 1000, rounded). */
export function radiusToKm(meters: number): number {
  return Math.round(meters / 1000);
}

/** Travel radius formatted as a "N km" string. */
export function formatRadiusKm(meters: number): string {
  return `${radiusToKm(meters)} km`;
}
